import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import i18n from '@/app/config/i18n';
import { UserProvider } from '@/providers/user-provider';

interface UserState {
  supplierId: string;
  isAdmin: boolean;
  isAuthenticated: boolean;
  userProvider: UserProvider;
  jwtToken: string | null;
  moduleIdsInUse: string[] | null;
  availableActions: {
    global: string[];
    auditCase: string[];
  };
  setIsAuthenticated: (auth: boolean) => void;
  setModuleIdsInUse: (moduleIdsInUse: string[] | null) => void;
  setAvailableActions: (availableActions: { global: string[]; auditCase: string[] }) => void;
  logout: (shouldRedirect?: boolean) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      supplierId: '',
      jwtToken: null,
      isAuthenticated: false,
      isAdmin: false,
      moduleIdsInUse: null,
      userProvider: new UserProvider(i18n.language),
      availableActions: { global: [], auditCase: [] },
      setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setModuleIdsInUse: (moduleIdsInUse) => set({ moduleIdsInUse }),
      setAvailableActions: (availableActions) =>
        set({
          availableActions,
        }),
      logout: (shouldRedirect = true) => {
        localStorage.removeItem('user-storage');
        if (shouldRedirect) {
          window.location.replace(import.meta.env.VITE_PLATFORM_WEB_LOGOUT_URL);
        }
      },
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        jwtToken: state.jwtToken,
        isAuthenticated: state.isAuthenticated,
        supplierId: state.supplierId,
        isAdmin: state.isAdmin,
        availableActions: state.availableActions,
      }),
    },
  ),
);
